var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.779,
    height: 16.114,
    viewBox: "0 0 16.779 16.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7250",
    "data-name": "Group 7250",
    transform: "translate(-878.871 -1490.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15663",
    "data-name": "Path 15663",
    d: "M883.3,1499.089a21.292,21.292,0,0,0,5.112,5.109l.481-.68a1.734,1.734,0,0,1,2.532-.451q1.06.729,2.11,1.472a1.706,1.706,0,0,1,.6,2.307,3.081,3.081,0,0,1-2.752,1.766,7.38,7.38,0,0,1-3.9-.888,16.846,16.846,0,0,1-7.689-7.651,7.584,7.584,0,0,1-.926-3.777,3.15,3.15,0,0,1,1.9-2.994,1.688,1.688,0,0,1,2.057.5c.592.8,1.166,1.607,1.7,2.44a1.693,1.693,0,0,1-.437,2.275C883.852,1498.711,883.589,1498.887,883.3,1499.089Z",
    transform: "translate(0 -2.174)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15664",
    "data-name": "Path 15664",
    d: "M917.93,1490.343q2,0,3.992,0c.417,0,.517.1.517.506q0,2.271,0,4.541c0,.406-.1.508-.517.509-1.446,0-2.892.008-4.339-.006a.421.421,0,0,0-.452.294c-.185.424-.387.839-.583,1.259-.089.192-.159.415-.426.41-.249,0-.319-.215-.4-.4-.2-.436-.416-.868-.609-1.309a.349.349,0,0,0-.389-.252c-.3.019-.6.01-.9,0s-.409-.118-.409-.405q-.006-2.372,0-4.744c0-.3.124-.4.467-.4Q915.9,1490.341,917.93,1490.343Zm.014,1.738c-.78,0-1.56-.01-2.339.009a.543.543,0,0,0-.394.207c-.147.237.063.473.406.474q2.3,0,4.593,0c.3,0,.471-.135.466-.353s-.171-.337-.479-.338Q919.071,1492.079,917.944,1492.081Zm-.05,2.08c.77,0,1.54,0,2.31,0,.3,0,.472-.131.471-.348s-.169-.342-.474-.343q-2.282,0-4.563,0c-.309,0-.468.122-.467.345s.161.344.47.346C916.392,1494.163,917.143,1494.161,917.894,1494.161Z",
    transform: "translate(-26.79)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.b2127e736625ccc6df6b59381a34f5a2.svg";
export { ForwardRef as ReactComponent };